/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import * as React from 'react';
import { AdaptiveCardsTemplate } from '../../components/AdaptiveCards';

export type AdaptiveCardEntryProps = Record<string, unknown>;

const isObject = (value: unknown): value is Record<string, unknown> =>
    value !== null && typeof value === 'object';

export const AdaptiveCardsView: React.FC<AdaptiveCardEntryProps> = (props) => {
    const schema = props.adaptiveCardsSchema;

    if (!isObject(schema)) {
        return null;
    }

    return <AdaptiveCardsTemplate schema={schema} data={props} />;
};
